import React, { useEffect, useRef } from 'react';
import {  } from 'antd';
import { autoTrackImp } from '@base/lib/Tracker'
import { IImage, IListItem } from '@pro/activity/testerClub/interface'
import Image from '@base/lib/ThemeImage'
import { IThemeSwiperRef, ThemeSwiper } from '@base/lib/ThemeSwiper'
import cn from 'classnames';

type IProps = {
    className?: string;
    product: IListItem;
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

const ProductImages: React.FC<IProps> = (props) => {
    const cardsRef = useRef<IThemeSwiperRef>(null);
    const { className, product } = props

    return(
        <ThemeSwiper
            ref={cardsRef}
            className={cn(className)}
            slidesPerView={'auto'}
            slidesPerGroup={1}
            scrollbar={isPhone}
            navigation={!isPhone}
            spaceBetween={0}
            centeredSlides={true}
            onSlideChange={autoTrackImp}
            list={product.images || []}
            render={(item: IImage, index) => (
                <Image
                    key={index}
                    alt={item.alt}
                    src={item.url}
                    fixed
                    height={isPhone ? 295 : 418}
                    width={isPhone ? 295 : 418}
                    background={false}
                    fit="cover"
                />
            )}
        />
    );
};

export default ProductImages